// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ga-2 {\n  gap: 8px;\n}\n.ga-4 {\n  gap: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
